import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      if (getToken() === t) setUser(data);
    } catch {
      if (getToken() === t) setUser(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (token, u, remember = false) => {
    localStorage.removeItem("kh_token");
    sessionStorage.removeItem("kh_token");
    (remember ? localStorage : sessionStorage).setItem("kh_token", token);
    setUser(u);
  };
  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* already logged out */
    }
    localStorage.removeItem("kh_token");
    sessionStorage.removeItem("kh_token");
    setUser(null);
  };
  const isPaid = !!user && ["student", "professional", "studio"].includes(user.effective_tier);
  const isAdmin = user?.role === "admin";
  return <AuthCtx.Provider value={{ user, ready, setUser, refresh, signIn, signOut, isPaid, isAdmin }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
